import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AclToolsService } from '../../../acl/tools/acl-tools.service';
import { AclResource } from '../../../acl/tools/decorators/acl-resource';
import { AccountDataFormAclService } from '../../../common-logic/account-data-form/account-data-form-acl.service';

export const ACL_RESOURCES = {
  GET_ADVERTISER: 'advGetAdvertiser',
  EDIT_ADVERTISER: 'advUpdateAdvertiser',
};

@Injectable({
  providedIn: 'root',
})
export class AdvertiserDataFormAclService extends AccountDataFormAclService {
  @AclResource(ACL_RESOURCES.GET_ADVERTISER)
  public canShowForm$: Observable<boolean>;

  @AclResource(ACL_RESOURCES.EDIT_ADVERTISER)
  public canEditForm$: Observable<boolean>;

  public readonly canEditLogo$: Observable<boolean> = of(false);
  public readonly canShowLogo$: Observable<boolean> = of(false);

  constructor(
    public aclTools: AclToolsService,
  ) {
    super();
  }
}
